export default __webpack_public_path__ + "static/media/sort-down.9b954fe7.svg";